// extracted by mini-css-extract-plugin
module.exports = {"CTABody":"CallToAction1_CTABody__G9rNG","CTAContainer":"CallToAction1_CTAContainer__2TqAY"};